import React from 'react'

import launcherIcon from '../../icons/launcher.png'
import xIcon from '../../icons/x.png'

import { useEndConversationModalContext } from '../EndConversationModal/context'

import { setWidgetColor } from './styles'
import { CountUnreadMessages } from './CountUnreadMessages'
import { useCountUnreadMessagesContext } from './CountUnreadMessages/context'
import widgetStorage from '../../actions/storage'

export const LaunchButton = props => {
  const { classes } = props
  const { unreadMessages } = useCountUnreadMessagesContext()
  const { setIsOpenEndConversationModal } = useEndConversationModalContext()

  const onClick = () => {
    if (props.isHiddenWidget) {
      props.handleViewWidget()
      return
    }
    const chatId = widgetStorage.tryFindChatIdInAnyStorage()
    if (!chatId) {
      props.toggleWidget()
      return
    }
    if (!props.isWidgetOpened) {
      setIsOpenEndConversationModal(true)
      return
    }
    if (props.isWidgetOpened) {
      props.toggleWidget()
    }
  }

  return (
    <div
      onClick={onClick}
      className={classes.containerLauncher}
      style={setWidgetColor(props.settings.color)}>
      {props.isWidgetOpened ? (
        <img className={classes.logo} src={launcherIcon} alt="open widget" />
      ) : (
        <img className={classes.xIcon} src={xIcon} alt="close widget" />
      )}
      {props.isHiddenWidget && !!unreadMessages && <CountUnreadMessages />}
    </div>
  )
}
